import i18n, { InitOptions } from 'i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import moment from 'moment'
import { timeFormat } from './utils'
// import 'moment/dist/locale/en-us'
import 'moment/dist/locale/fr'
import 'moment/dist/locale/ko'
import 'moment/dist/locale/ru'
import 'moment/dist/locale/zh-cn'
import 'moment/dist/locale/ja'

import localforage from './myStore'
import conf from './conf'

// const momentLocales = {
//   'en-US': 'en-us',
//   'fr-FR': 'fr',
//   'ko-KR': 'ko',
//   'ru-RU': 'ru',
//   'zh-CN': 'zh-CN',
// };

export interface LanguageInfo {
  name: string
  code: string
}

export type LanguageMap = {
  [key: string]: LanguageInfo
}

export const languageMap: LanguageMap = {
  ko: { name: '한국어', code: 'ko-KR' },
  en: { name: 'English (US)', code: 'en-US' },
  ja: { name: '日本語', code: 'ja-JP' },
  fr: { name: 'Français', code: 'fr-FR' },
  ru: { name: 'Русский', code: 'ru-RU' },
  zh: { name: '简体中文', code: 'zh-CN' },
}

const hash: string | number =
  conf.gitInfo && conf.gitInfo.commit && conf.gitInfo.commit.hash
    ? conf.gitInfo.commit.hash
    : new Date().getTime()

const i18nOptions: InitOptions = {
  // saveMissing: true,
  fallbackLng: 'en-US',
  load: 'currentOnly',
  debug: conf.DEBUG === true,
  // @ts-expect-error i18next v24+ 옵션, 현재 타입 정의에 미포함
  showSupportNotice: false,

  backend: {
    // for all available options read the backend's repository readme file
    loadPath: `/locales/{{lng}}/{{ns}}.json?cb=${hash}`,
  },

  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
    format: (value: any, format?: string): string => {
      console.log(' ------ ', value, format)
      if (value instanceof Date)
        return timeFormat(value.toISOString(), format || 'YYYY-MM-DD HH:mm:ss')
      return value
    },
  },
}

let instance = i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)

const locale = await localforage.getItem<string>('app.settings.locale')

if (conf.defaultLocale == null && locale == null) {
  instance = instance
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
} else if (locale == null) {
  i18nOptions.lng = conf.defaultLocale
} else {
  i18nOptions.lng = locale
}

instance
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init(i18nOptions)

i18n.on('languageChanged', (lng: string) => {
  moment.locale(lng)
  document.documentElement.lang = lng.substring(0, 2).toLowerCase()
})

export default i18n
